<template>
  <div class="main-content" style="padding-top: 0px">
    <div class="box-left-logo">
      <img @click="$router.push('/')" src="@/assets/image/header/logo.png" alt="logo" style="cursor: pointer">
    </div>
    <div class="exchange">
      <img src="@/assets/image/erwei.png" alt="erwei" />
      <h3>兌換QR Code</h3>
    </div>
    <div class="exchangeBody">
      <div class="left">
        <img class="Pc" src="@/assets/image/perPc.png" alt="perPc" />
        <img class="Mb" src="@/assets/image/perMb.png" alt="perMb" />
        <div>
          <p>提醒您兌換成eSIM QR code後，</p>
          <p>需在<span style="color: red;">30天內將其安裝</span>到您的手機上並使用完畢，方案時間按安裝時起算。</p>
          <p style="color: #fff;"><span style="color: red;">部分方案兌換後起算方案天數</span>，詳情請參考方案介紹頁面，若因操作不當導致過期恕不退費。</p>
          <!-- <p>提醒您兌換成eSIM QR code後，</p>
          <p>需在30天內將其安裝到您的手機上並使用完畢</p>
          <p>否則QR code及行動方案將在此後過期</p>
          <p>方案時間按安裝時起算</p> -->
        </div>
      </div>
      <div class="right">
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAAWCAYAAAALmlj4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAWJSURBVHgB7Vq9cttGEN6DZGkyViZwmSpwlTJUCieZFIaeINRMxlYqgU8g6glMPUGoJxDZZOJxJqKfQFDlyI2pMlWgKqWQwokUSrjsknvm8giCIAWRlCbfzA1wt3vAHvb3jlSQgoc//FaFRP1ojyegq/+8/HofMuBuvfE6eukAQPtyXANEiUo2Ln7+JoIFAst7iBK6cM+gFDSX5YBbfud2VjuHkKQoJ1HBxauvjrMe+PGzk3JHw8HQx9JQX/l3ZS9urcewYOhoZwcFLME9hNbwQpnO2tYbX2sHlQPeABNAa+VypdL56DJAr94Zfoyqv3/5ZH/t+du6Bm3TY/T62jivn0zorvFsYyvZsiIibmRIx0qptpgjZTtFWotueN1HcB+BjtVV8NrWSY20bdMpJK9erjavVju1NOU5GipLTtLuJBjilOUFWrWvnevNIkMyKqqKF5IzTzgNUYkbPM/Dyx+C1kBaxXQocl04+hO4g/jed93PP33wyPR//7Nz/ksYdyPlxa9fnqmHz98e2fkSNR/D8tXGg8SJOz3r9gbJvXyK9FKiKCQPfnDj9UWGZFSSj5dJPC23gu8yUr5LgGtrms7ykHJpkoL475++bVP4guEwSBwheabz7GRbpXmThvYt5Fs7wkTY6tALxwSXm8cthP8By3B3IFMAKXUdLXXhirZFw9wUzIUP5dQvoKe8mBsVP69ReZE1RUaKdlHKTSnAaKfQZtme8nvpXRTWm8xP8ppCD7LkRv4S89E6PehHmXjMvDLP6QLpezzus7x7LJ+9AyhzSurKdSMFa6VjBWryeVoHeKF9dlqx5GPDok9XTKWbghItIsUIpgHJUBP9CFLTEvgsdwlGy11FHjuyHEF2UWjmbZqqn/EdtsB0kE6GJ3c5lJ6qMCxrmVt3LQ7cAI7Sf8GEYOuyCzNjzQZEOxCWSIgs+hHSd9iii4SXQfMhW1keDEYDQp5I40HP4LMwVOzmwY0UPCXkQmjxPlruI2p4vytoduhsWM/xoGfFpOhzbHTdtoxiGnTDMfS8I4BeuLYRCnrDogVWf4/HfGzr0C8CqR8JPp/Dfx60Wc56yvsp6tW41Weag3kBZSkMKvbD6Rje15GHQpPPQ8RrlL7P/VLKo12e4/N76visXZgOdZPv+FmvobfFcoXMm4K/yUblc9+TD0PeBqTjDOeRMqpijPbiozzeKHRfpIBTjmCB4GvJbdKsPdhWTpjCE4l7z9zQorCRB1Rg/BaIctq4kJcL/DEjMZRmYANeju/+DDJABsHFV16PJTwmw5u0uMz0YH29FIOjI3tc6akrWHtBVS5cJAY+IHm9XBR7RIO9xlTgPvQ9SD574g8yAvG0dLFbMBXvJEr9gGnXkang96+ekGU+huJgL640bsKohXEFTY1C6B4r3C5E6L4NcwIr9x1MURwVhXkfdIQwGP5s5LZaUviInDZPUM3giT7J14C+0QUwuEUrHLNWsO1NDVkQFICpwt8t4qnV35V7dzRIuG3MusiKrH4AOUHhLmsbYVWyBqewWCiiHhiHgbQ3Uw+mfIqKCKGvCNr70aEHebY8NDFVaCQ8/JD5zaFIJPjN8aFEuABn1fb7X/C2Sx53SlSQ3pjwhM7mrbKx07vdeeRg2mP6oh9k8Daw2SHchf557ijQ4hbh50BSpqwJqlbfBv1iRnvuCHKCa4+uMsVwma/xzE+yUKAQL3RQEMHtIMS2UdA59Y3Aa61lsBC9iCp/1KGOu4x5vmaP0o8IkAdO0tZXTm1o2Eky/7vFPyK00PLsvaEJv5Q7z5HvTMwxP94TP1XHHgx6cQS9v+KkfbDukajon+WkGexCvyJPO3+nKBMKWaXctIUjOp3QudBPL8cmhfB38HiK+XZ0cteAHKCzAU595h3A7zj9DyivZWUVW50qAAAAAElFTkSuQmCC"
          alt="">
        <el-input v-model="ruleForm.snPin" placeholder="輸入兌換碼"></el-input>
        <el-input v-model="ruleForm.email" placeholder="輸入電子郵件"></el-input>
        <el-button type="primary" @click="submitForm('ruleForm')">確認</el-button>
        <!-- <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm">
          <el-form-item label="電子信箱" prop="email">
            <el-input v-model="ruleForm.email" placeholder="輸入電子郵件"></el-input>
          </el-form-item>
          <el-form-item label="確認電子信箱" prop="perEmail">
            <el-input v-model="ruleForm.perEmail" placeholder="重複輸入電子郵件"></el-input>
          </el-form-item>
          <el-form-item label="兌換碼" prop="snPin">
            <el-input v-model="ruleForm.snPin" placeholder="輸入兌換碼"></el-input>
          </el-form-item>
          <el-form-item class="btn">
            <el-button type="primary" @click="submitForm('ruleForm')">確認</el-button>
          </el-form-item>
        </el-form> -->
      </div>
    </div>
  </div>
</template>
<script>
  import { queryResult, submit_exchange } from "@/request/api";
  import { Loading } from "element-ui";

  export default {
    name: 'index.vue',
    data() {
      return {
        ruleForm: {
          email: '',
          perEmail: '',
          snPin: ''
        },
        loadingInstance: null,
        snpin_id: null,
        rules: {
          email: [
            { required: true, message: '請輸入信箱', trigger: 'blur' },
            { type: 'email', message: '請輸入正確的信箱', trigger: ['blur', 'change'] }
          ],
          perEmail: [
            { required: true, message: '請再次輸入信箱', trigger: 'blur' },
            { type: 'email', message: '請輸入正確的信箱', trigger: ['blur', 'change'] },
            { validator: this.validateEmails, trigger: 'blur' }
          ],
          snPin: [
            { required: true, message: '請輸入兌換碼', trigger: 'blur' }
          ]
        }
      }
    },
    mounted() {
      if (this.$route.query.code) {
        this.$set(this.ruleForm, 'snPin', this.$route.query.code)
      }
      if (this.$route.query.email) {
        this.$set(this.ruleForm, 'email', this.$route.query.email)
      }
    },
    methods: {
      validateEmails(rule, value, callback) {
        if (value !== this.ruleForm.email) {
          callback(new Error('兩個信箱不一致'));
        } else {
          callback();
        }
      },
      validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      },
      submitForm(formName) {
        if (!this.ruleForm.snPin) {
          this.$message.warning('請輸入兌換碼')
          return
        }
        if (!this.ruleForm.email) {
          this.$message.warning('請輸入電子郵件')
          return
        }
        if (!this.validateEmail(this.ruleForm.email)) {
          this.$message.warning('請輸入正確電子郵件')
          return
        }
        this.send()
        // this.$refs[formName].validate((valid) => {
        //   if (valid) {
        //     this.send()
        //   } else {
        //     console.log('error submit!!');
        //     return false;
        //   }
        // });
      },

      async send() {
        let res = await submit_exchange(this.ruleForm)
        if (res.code == 200) {
          this.snpin_id = res.data.snpin_id
          this.loadingInstance = Loading.service({
            lock: true,
            text: '兌換中......'
          })
          setTimeout(this.getQrcodeUrl(), 5000)
        } else {
          this.$message.warning(res.msg)
        }
      },
      async getQrcodeUrl() {
        let res = await queryResult({ snpin_id: this.snpin_id })
        if (res.code == 200) {
          await this.$router.push({
            path: 'exchangeDetail',
            query: { obj: JSON.stringify(res.data), email: this.ruleForm.email, code: this.ruleForm.snPin }
          })
          this.loadingInstance.close()
        } else {
          setTimeout(this.getQrcodeUrl, 5000)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .exchange {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin-bottom: 80px;
    margin-top: 80px;

    h3 {
      font-size: 32px;
      line-height: 44px;
      color: #ffffff;
      font-weight: bolder;
    }
  }

  .exchangeBody {
    padding: 80px 40px;
    background: #1E1E1E;
    border-radius: 10px;
    display: flex;
    align-items: center;
    /* align-items: start; */
    flex-wrap: wrap;
    gap: 80px;

    .left {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 40px;
      padding-top: 20px;
      width: 400px;

      .Pc {
        display: block;
      }

      .Mb {
        display: none;
      }

      p {
        font-size: 18px;
        line-height: 25px;
        color: #ffffff;
      }

      p:nth-child(3) {
        color: #FFC700;
      }
    }

    .right {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;

      ::v-deep .el-form-item__label {
        color: #ffffff;
        font-size: 16px;
        margin-top: 10px;
      }

      ::v-deep .el-input__inner {
        /* background: #2E2E2E; */
        background: #fff;
        border: none;
        border-radius: 10px;
        margin-top: 10px;
        color: #000;
        text-align: center;
      }

      .btn {
        text-align: right;
        margin-top: 40px;
      }

      .el-button {
        max-width: 100px;
        background: #0B57C9;
        color: #ffffff;
        border: none;
        padding: 7px 30px;
        border-radius: 20px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .exchange {
      margin-top: 40px;
      margin-bottom: 0px;

      h3 {
        font-size: 24px;
        line-height: 34px;
      }
    }

    .exchangeBody {
      background: transparent;
      padding: 30px 20px;

      .left {
        display: block;
        text-align: center;
        width: 100%;
        padding-top: 0px;

        img {
          margin: 20px auto;
        }

        .Pc {
          display: none;
        }

        .Mb {
          display: block;
        }

        p {
          font-size: 14px;
          line-height: 20px;
        }
      }

      .right {
        ::v-deep .el-form-item__label {
          display: none;
        }

        ::v-deep .el-form-item__content {
          margin-left: 0px;
        }

        .btn {
          text-align: center;
        }
      }
    }
  }
</style>